<template>
  <p
    class="text-xs font-semibold tracking-wide"
    :class="{
      'text-primary': color === 'primary',
      'text-brand': color === 'brand'
    }"
  >
    <slot />
  </p>
</template>

<script setup lang="ts">
export type FlourishColor = 'primary' | 'brand'

withDefaults(
  defineProps<{
    color?: FlourishColor
  }>(),
  {
    color: 'primary'
  }
)
</script>
